import appConfig from './Config';

export default {
  oidc: {
    clientId: appConfig.appClientId || '',
    issuer: appConfig.oktaIssuer || '',
    redirectUri: appConfig.oktaReturnUrl || '',
    pkce: true,
    scopes: ['openid', 'profile', 'email', 'phone',],
    tokenManager: {
      autoRenew: true,
      // Keep localStorage for session persistence across tabs/browser restarts
      // Safari Storage Access API (in App.tsx) handles cross-origin issues
      storage: 'localStorage',
    },
    // Enhanced cookie settings for Safari
    cookies: {
      secure: true,
      sameSite: 'none', // Required for cross-origin contexts
    },
  },
};
